import { DASHBOARD_TYPE } from 'constants/enums'
import { getEnv } from 'utils/environment'

const docsUrl = getEnv('NEXT_PUBLIC_FAROS_API_DOCUMENTATION')

export default {
  ROOT: '/', // this will be redirected correct landing page via the GraphRouter.tsx logic
  INSPECT: {
    APPS: '/apps',
    GRAPHQL: '/graphql',
    SCHEMA: '/schema',
  },
  SOURCES: {
    ROOT: '/sources',
    CATALOG: '/catalog',
    NEW: '/sources/new',
    EVENTS: '/events',
    DATA_CLEANUP: '/data-cleanup',
  },
  SCHEMA: '/schema',
  DOCS: {
    FAROS_DOCS: docsUrl,
    FAROS_DOCS_SCORECARD: `${docsUrl}/docs/scorecard`,
    FAROS_SUPPORT: getEnv('NEXT_PUBLIC_FAROS_SUPPORT_URL'),
  },
  SETTINGS: {
    GRAPHS: '/graphs',
    API_KEYS: '/api-keys',
    CREDENTIALS: '/credentials',
    DELTA_SHARES: '/delta-shares',
    DELTA_SHARES_RECIPIENTS: '/delta-share-recipients',
    USERS: '/users',
    INVOICES: '/invoices',
    FLOWS: '/flows',
    WORKFLOWS: '/workflows',
    WORKFLOWS_MANAGEMENT: '/workflows-management',
  },
  ACCESS_CONTROL: {
    ROOT: '/access-control',
    ROLES: '/access-control/roles',
  },
  PROFILE: '/profile',
  PAGES: {
    CUSTOM: {
      ROOT: '/page',
      PAGE: '/page/custom/:page',
    },
  },
  PAGE_BUILDER: '/page-builder',
  TEAMS: {
    MY_TEAM: '/my-team',
    ROOT: '/teams',
    TEAM: '/teams/:team',
    SCORECARD: '/teams/scorecard',
    EMPLOYEES: '/teams/employees',
    ASSIGN_CONNECTIONS: `/teams/employees/assign-connections`,
    EMPLOYEE_DETAIL: '/teams/employees/:employee',
    APPLICATION_OWNERSHIPS: `/teams/ownership/application`,
    REPOSITORY_OWNERSHIPS: `/teams/ownership/repository`,
    TASK_BOARD_OWNERSHIPS: `/teams/ownership/task-board`,
    PIPELINE_OWNERSHIPS: `/teams/ownership/pipeline`,
    // OWNERSHIP: `/teams/ownership/:type(${TEAM_OWNERSHIP_PATTERN})`,
  },
  ACCOUNT: {
    ROOT: '/account',
    SEATS: '/seats',
    SUBSCRIPTION: '/subscription',
    SEATS_FULL_ROUTE: '/account/seats',
    SUBSCRIPTION_FULL_ROUTE: '/account/subscription',
  },
  DASHBOARDS: {
    ROOT: '/dashboards',
    DASHBOARD: '/dashboards/dashboard',
    ORGANIZATION_DORA_SUMMARY: `/dashboards/dashboard/${DASHBOARD_TYPE.ORGANIZATION_DORA_SUMMARY}`,
    ORGANIZATION_EP_SUMMARY: `/dashboards/dashboard/${DASHBOARD_TYPE.ORGANIZATION_EP_SUMMARY}`,
    COLLECTIONS: '/dashboards/collection',
    PERSONAL_COLLECTION: '/dashboards/personal-collection',
    QUESTIONS: '/dashboards/question?notebook',
    REFERENCES: '/dashboards/reference/databases',
    PUBLIC_SHARING: '/dashboards/sharing',
    NEW_QUESTION: '/dashboards-new-question',
  },
  GRAPH: '/:graph',
  API: {
    AUTH: {
      LOGIN: '/api/auth/login',
      LOGOUT: '/api/auth/logout',
    },
    GRAPHQL: '/v0/graphql',
    FAROS_API_PROXY: '/api/faros',
    JIRA_API_PROXY: '/api/jira',
    UNLEASH_API_PROXY: {
      ROOT: '/api/unleash',
      PROXY: '/api/unleash/proxy',
    },
    METABASE: {
      DASHBOARD: '/api/metabase/dashboard',
      DASHBOARDS: '/api/metabase/dashboards',
      DASHBOARD_IDS: '/api/metabase/dashboard-ids',
      DATABASE: '/api/metabase/database',
      COLLECTIONS: '/api/metabase/collections',
      DYNAMIC_DASHBOARD: '/api/metabase/dynamic-dashboard',
      DASHBOARD_METADATA: '/api/metabase/dashboard-metadata',
      TENANT_COLLECTION: '/api/metabase/collections/tenant',
      FIELD_DISTINCT_VALUES: '/api/metabase/field-distinct-values',
      SSO_SESSION: '/api/metabase/sso-session',
    },
    SEGMENT: '/api/segment',
    SEGMENT_V1: '/api/segment/v1',
    BILLING: {
      INFO: '/api/billing/info',
      SUBSCRIPTION: '/api/billing/subscription',
    },
    LICENSE: {
      ROOT: '/api/license',
      SEATS: '/api/license/seats',
    },
    PIPELINE_ALIASES: '/api/pipelines/aliases',
    SENDGRID: {
      CONTACT_SALES: '/api/sendgrid/contact-sales',
      CONTACT_BILLING: '/api/sendgrid/contact-billing',
    },
    DATE: '/api/date',
    TEAMS: {
      SCORECARD: '/api/teams/scorecard',
      STATUS: '/api/teams/status',
    },
  },
  LAYOUT_BUILDER: '/layout-builder',
  METABASE: '/metabase',
  METABASE_DUCK_DB: '/reports/metabase',
  NEXT_AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
  },
  SSO_AUTH: {
    README: '/auth/sso/readme',
  },
  FRONTEGG_AUTH: {
    ROOT: '/account',
    LOGOUT: '/account/logout',
  },
  UNAUTHORIZED: '/unauthorized',
  UNAUTHORIZED_LANDING_PAGE: '/unauthorized-landing-page',
  LIGHTHOUSE_AI: '/lighthouse-ai', // default lighthouse AI flow
  LIGHTHOUSE_AI_EXPLANATION: '/lighthouse-ai-explanation', // tailer lighthouse AI flow
  DEMO: {
    SERVICES: '/services',
    EMPLOYEE: '/employee',
    SOLUTIONS_PAGES: {
      KEYSTONE_INITIATIVE: '/solutions-page/keystone-initiative',
      ENGINEERING_PRODUCTIVITY: '/solutions-page/engineering-productivity',
      INITIATIVE_TRACKING: '/solutions-page/initiative-tracking',
      INITIATIVE_TRACKING_2: '/solutions-page/initiative-tracking-2',
      ORCHESTRATION_TEAM: '/solutions-page/orchestration-team',
    },
  },
  UNSUPPORTED_BROWSER: '/unsupported-browser',
  GUIDED_EXPLORATION: '/guided-exploration',
  INITIATIVES: '/initiatives',
  RND_CAPITALIZATION: '/rnd-capitalization',
  LIGHTHOUSE_NOTEBOOK: '/lighthouse-notebook',
  COPILOT_EXTENSION: {
    AUTH_LINK: '/copilot-extension/auth-link',
  },
} as const
